import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { IContentLibraryListResponse } from './types';

// Hook to fetch available content library items
// Used by Form Builder to show available data sources
// Admin-only endpoint (uses RoleGuard, no corporationId required)
export function useContentLibraryItems(token?: string) {
  const { data, mutate, error, isLoading } =
    useSWR<IContentLibraryListResponse>(
      'content-library',
      SWRFetcher({ method: 'GET' }, token)
    );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
